module.exports = __webpack_public_path__ + "img/organ.4a751445.svg";